import React from 'react';

import { TlidDrawer } from './TlidDrawer';
import { buildFileChips, buildSegmentOptions } from './utils';
import type { SegmentLabels } from './utils';
import type { BeraSegmentAssignment } from '@/types/Bera';

interface IdentifiedFileDrawerProps {
	fileId: string;
	fileName: string;
	segmentLabels: SegmentLabels;
	assignments: BeraSegmentAssignment[];
	onClose: () => void;
	onSave: (segmentIds: string[]) => void;
}

export function IdentifiedFileDrawer({
	fileId,
	fileName,
	segmentLabels,
	assignments,
	onClose,
	onSave
}: Readonly<IdentifiedFileDrawerProps>): JSX.Element {
	const options = buildSegmentOptions(segmentLabels, assignments, fileId);
	const chips = buildFileChips(segmentLabels, assignments, fileId);
	const selectedSegmentIds = chips.map((chip) => chip.segmentId);

	return (
		<TlidDrawer
			key={fileId}
			options={options}
			fileName={fileName}
			selectedSegmentIds={selectedSegmentIds}
			onClose={onClose}
			onSave={onSave}
		/>
	);
}
